import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Button from "components/common/buttons/buttons";
import { useTranslation } from "next-i18next";
import Title from "components/common/title";
import MonetaryBtn from "components/common/monetaryBtn";
import InterestAssetList from "components/templates/common/Interest/AssetList";
import { ICONS } from "components/common/Icons";
import SelectModal from "components/modals/SelectOptionModal";
import { useSortDispatch, useSortState } from "contexts/SortContext";
import { INTEREST_SORT } from "utils/constant/STATUS";
import InterestToggleButton from "components/templates/common/Interest/ToggleButton";
import InterestEditButton from "components/templates/common/Interest/EditButton";
import { trackPageAction } from "lib/analytics/core/actions";
import { TrackedLink } from "lib/analytics/react/link";
import { useWatchlist } from "lib/analytics/react/hooks";

interface Props {
  data: any[];
  isValid: boolean;
  session: any;
  newsRaderData: any;
}

function InterestTable({ session, data, isValid, newsRaderData }: Props) {
  const router = useRouter();
  const { t } = useTranslation("watchlist");
  const { add, remove } = useWatchlist();

  const [sortedData, setSortedData] = useState(data);

  const [toggleActive, setToggleActive] = useState(false);

  const [sortSelectModal, setSortSelectModal] = useState(false);

  const { WATCHLIST_SORT: sortSelected } = useSortState();
  const sortDispatch = useSortDispatch();
  const setSortSelected = (sortIndex: 0 | 1 | 2 | 3) => {
    sortDispatch({ type: "SET_WATCHLIST_SORT", payload: { sort: sortIndex } });
  };

  useEffect(() => {
    let sorted = [...(data || [])];

    switch (sortSelected) {
      case 0:
        break;
      case 1:
        sorted.sort((a, b) => a.ITEM_KR_NM.localeCompare(b.ITEM_KR_NM));
        break;
      default:
        break;
    }

    setSortedData(sorted);
  }, [sortSelected, data]);

  return (
    <div
      className={`flex flex-col  ${
        data?.length > 0 ? "overflow-y-auto " : ""
      } `}
    >
      <div
        className={`flex-grow  ${
          data?.length > 0 ? "overflow-y-auto " : ""
        } pb-4 `}
      >
        {data && data.length > 0 && (
          <>
            <div className="px-6 flex justify-between items-center my-4">
              <Button
                icon={ICONS.EXPAND}
                iconHeight={16}
                iconWidth={16}
                text={
                  INTEREST_SORT[sortSelected][router.locale === "ko" ? 0 : 1]
                }
                clickHandler={() => {
                  trackPageAction("sort_watchlist");
                  setSortSelectModal(true);
                }}
                type="link_gray"
                size="md"
                dataGtmId={`watchlist-sort-btn`}
              />
              <div className="flex items-center gap-2">
                <InterestEditButton
                  editHandler={() => {
                    router.push("/watchlist/edit");
                  }}
                />
                <InterestToggleButton
                  hidden={!data || data?.length === 0}
                  isActive={toggleActive}
                  setIsActive={setToggleActive}
                />
              </div>
            </div>
          </>
        )}

        <InterestAssetList
          isValid={isValid}
          toggleActive={toggleActive}
          t={t}
          sortedData={sortedData}
          session={session}
          newsRaderData={newsRaderData}
        />
        {data && data.length > 0 && (
          <div className=" flex justify-center py-3 px-[24px]">
            <TrackedLink
              itemspec={{
                kind: "section_nav",
                section_id: "watchlist_stock_list",
                nav_key: "watchlist_navbtn_add_stock",
              }}
              href={
                !session
                  ? `/login?from=${router.asPath}&parent_intent_type=watchlist`
                  : "/watchlist/search"
              }
              asTrace={true}
            >
              <Button
                text={t("종목 추가하기")}
                size="lg"
                width="w-full "
                type="tertiary"
                // clickHandler={() => {
                //   if (!session) router.push("/login");
                //   else router.push("/watchlist/search");
                // }}
                icon={ICONS.PLUS}
                iconHeight={16}
                iconWidth={16}
                dataGtmId={`watchlist-add-btn`}
              />
            </TrackedLink>
          </div>
        )}
      </div>
      {sortSelectModal && (
        <SelectModal
          data={[
            ...INTEREST_SORT.map(
              (sort) => sort[router.locale === "ko" ? 0 : 1]
            ),
          ]}
          index={sortSelected}
          selectIndex={setSortSelected}
          setModal={setSortSelectModal}
          isModalOpen={sortSelectModal}
        />
      )}
    </div>
  );
}

export default InterestTable;
